import type {
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'

import { deletePacket } from './services/mutatePackets'
import { invalidateLoadPackets } from './useLoadPackets'

export type Props = {
  deletePacket: (id: string) => Promise<void>
} & UseMutationResult<void, Error, string>

export const useDeletePackets = (
  options: UseMutationOptions<void, Error, string> = {}
): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.PACKETS.DELETE],
    mutationFn: async (id: string) => await deletePacket(id),
    onSuccess: async () => {
      await invalidateLoadPackets()
    },
    ...options,
  })

  const deletePacketReq = async (id: string) => {
    return mutation.mutateAsync(id)
  }

  return {
    deletePacket: deletePacketReq,
    ...mutation,
  }
}
